/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGrafana extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGrafana");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGrafana.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGrafana>): ServiceAccountNativeDetailsForGrafana {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGrafana(), model);
        ServiceAccountNativeDetailsForGrafana.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGrafana>): ServiceAccountNativeDetailsForGrafana {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGrafana.newInstance(<ServiceAccountNativeDetailsForGrafana> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGrafana) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGrafana.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGrafana): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGrafana.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
